import React, { useEffect, useState } from 'react';
import './Sections.scss';
import Hyperlink from '../Hyperlink/Hyperlink';
import Factbox from '../Factbox/Factbox';

function Section1() {
  const [touch, setTouch] = useState(false);
  const hyperlinkData = [
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/mortgage-rates-back-above-7-percent',
      copy: 'the average 30-year fixed mortgage rate hit 7.08%',
      label: 'Read article, Mortgage Rates Back Above 7%'
    },
    {
      href: 'https://www.nar.realtor/magazine/real-estate-news/15-year-fixed-rate-mortgages-reach-record-low',
      copy: 'the record low average of 2.10% available in July 2021',
      label: 'Read article, 15-Year Fixed-Rate Mortgages Reach Record Low'
    },
    {
      href: 'https://www.nar.realtor/newsroom/home-prices-rose-year-over-year-in-98-of-metro-areas-in-third-quarter-of-2022',
      copy: 'making mortgage payments much less affordable',
      label:
        'Read article, Home Prices Rose Year-Over-Year in 98% of Metro Areas in Third Quarter of 2022'
    },
    {
      href: 'https://www.nar.realtor/lawrence-yun',
      copy: 'Dr. Lawrence Yun, Chief Economist at the National Association of Realtors®',
      label: "Visit Dr. Lawrence Yun's page"
    }
  ];

  useEffect(() => {
    const handleTouch = () => {
      setTouch(true);
      return () => window.removeEventListener('touchstart', handleTouch);
    };
    window.addEventListener('touchstart', handleTouch, { passive: true });

    return () => window.removeEventListener('touchstart', handleTouch);
  }, []);

  return (
    <section className="sections sections-section1">
      <p className="sections-copy">
        In 2020 and 2021, historically low interest rates and pandemic-driven social changes put
        home sellers in the driver’s seat, stimulating bidding wars among buyers and sending prices
        soaring from coast to coast.
      </p>
      <p className="sections-copy">
        That all changed in 2022. As the Federal Reserve raised the federal funds rate in an effort
        to combat inflation, mortgage rates rose as well. By early November 2022,{' '}
        <Hyperlink hyperlinkData={hyperlinkData[0]} /> — more than twice the historic low 2.98%
        average rate from a year before. The difference was even more dramatic for 15-year fixed
        mortgage rates, which reached 6.38% that week, more than three times higher than{' '}
        <Hyperlink hyperlinkData={hyperlinkData[1]} />.
      </p>
      <p className="sections-copy sections-copy--margin">
        Those rising mortgage rates collided with continued high median housing prices,{' '}
        <Hyperlink hyperlinkData={hyperlinkData[2]} /> for many aspiring homebuyers. Predictably,
        lower affordability led to a decline in home sales, with 16% fewer sales of existing homes
        in 2022 compared to the year before. Annual new home sales in 2022 declined at about the
        same rate with 17% fewer sales in 2022 than in the previous year.
      </p>
      <Factbox touch={touch} />
      <p className="sections-copy">
        Given all the dramatic changes last year, the big question is what can home buyers and
        sellers expect to happen in 2023? <Hyperlink hyperlinkData={hyperlinkData[3]} /> (NAR),
        reviewed the data, researched trends, and gave us several big predictions on what to expect
        in 2023:
      </p>
    </section>
  );
}

export default Section1;
